module.exports = __webpack_public_path__ + "ceb5cc61ee6d642994284413aa51078c.svg";